import React from 'react';
import PropTypes from 'prop-types';
import css from './styles.less';


const Loading = ({ theme, shape, shapeClassName, isRTL }) => {
    const shapeClassNames = `${css.shape} ${theme && css[theme]} ${shape && css[shape]} ${shapeClassName}`;

    return (
        <div className={`${css.loader} ${isRTL && css.rtl}`}>
            <div className={shapeClassNames}></div>
            <div className={shapeClassNames}></div>
            <div className={shapeClassNames}></div>
        </div>
    );
}

Loading.propTypes = {
    isRTL: PropTypes.bool,
    theme: PropTypes.string,
    shape: PropTypes.string
};

Loading.defaultProps = {
    isRTL: false,
    theme: 'dark',
    shape: ''
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/common/Loading/Loading.js